const fields = [
  {
    key: 'is_exhibition',
    type: 'boolean',
    options: [],
    templateOptions: {
      label: 'is_exhibition'
    }
  },
  {
    key: 'isFriendlyGame',
    type: 'boolean',
    options: [],
    templateOptions: {
      label: 'isFriendlyGame'
    }
  },
  {
    key: 'round',
    type: 'input',
    templateOptions: {
      label: 'round',
      attrs: {
        type: 'number'
      }
    }
  },
  {
    key: 'teamA',
    type: 'ntm-select',
    options: [],
    templateOptions: {
      label: 'teamA'
    }
  },
  {
    key: 'teamB',
    type: 'ntm-select',
    options: [],
    templateOptions: {
      label: 'teamB'
    }
  }
]

export default fields
